import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {TListItem} from './types';

export const getRefundList = (limit: number): TListItem[] => {
  return loopMap(limit, getRefundDetails) as TListItem[];
};

export const getRefundDetails = (): TListItem => {
  const statuses = [
    'ready_for_withdraw',
    'requested_by_merchant',
    'approved_by_buyer',
    'refund_done',
    'failed',
    'cancelled',
  ];
  return {
    id: faker.datatype.uuid(),
    merchant_id: faker.datatype.uuid(),
    merchant_name: faker.name.findName(),
    merchant_email: faker.internet.email(),
    order_id: faker.datatype.uuid(),
    ...(faker.datatype.boolean() ? {tx_id: faker.datatype.uuid()} : {}),
    fiat_code: faker.finance.currencyCode(),
    fiat_amount: faker.finance.amount(0, 1000, 2),
    asset_code: faker.finance.currencyCode(),
    ...(faker.datatype.boolean() ? {asset_amount: faker.finance.amount(0, 1000, 2)} : {}),
    life_flow: (faker.helpers as any).arrayElement(statuses),
    created_at: faker.date.recent().toISOString(),
    ...(faker.datatype.boolean() ? {updated_at: faker.date.recent().toISOString()} : {}),
    ...(faker.datatype.boolean() ? {to_address: faker.word.adjective()} : {}),
    ...(faker.datatype.boolean() ? {to_address_tag: faker.word.adjective()} : {}),
    ...(faker.datatype.boolean() ? {exchange_type: faker.word.adjective()} : {}),
  } as TListItem;
};
